import gtm from '@/utils/gtm';
import EfLink from '@elem/ui/ef-link';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import IconClose from '../../icons/IconClose';
import './index.scss';
import { textLang } from './textLang';

export default function WinShare({ gainConfig, callback, okCallback }: { gainConfig: any; callback: any; okCallback?: any }) {
    const [gainConfig2, setGainConfig2] = useState<any>({});
    const refDialog = useRef<any>(null);
    const { locale = 'us' } = useRouter();
    const TextA = textLang[locale] || textLang['us'];
    const closeHandle = () => {
        callback && callback();
    };
    useEffect(() => {
        refDialog.current.showModal();
    }, []);
    useEffect(() => {
        const getGainConfig = () => {
            let gainConfigB = {};
            try {
                gainConfigB = JSON.parse(gainConfig);
            } catch (error) {}
            setGainConfig2(gainConfigB);
        };
        getGainConfig();
    }, [gainConfig]);
    // 分享
    const openHrefHandle = async (href: string, type: string) => {
        const gainConfig2B = JSON.parse(JSON.stringify(gainConfig2));
        delete gainConfig2B[type];
        setGainConfig2(gainConfig2B);
        if (JSON.stringify(gainConfig2B) === '{}') {
            okCallback && okCallback(type, href, true);
        } else {
            okCallback && okCallback(type, href);
        }
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'share',
                method: type,
                item_id: 'Make up for check-in',
            });
        } catch (error) {}
    };

    return (
        <dialog className="ef-check-in-dialog ef-check-in-dialog-share" ref={refDialog}>
            <div className="ef-check-in-dialog-wrap">
                <div className="ef-check-in-dialog-body">
                    <div className="ef-check-in-dialog-title">{TextA.titleShare}</div>
                    <button className="ef-check-in-dialog-close" onClick={closeHandle}>
                        <IconClose />
                    </button>
                    <div className="ef-check-in-dialog-share-list">
                        {gainConfig2.Instagram && (
                            <EfLink
                                className="ef-check-in-dialog-share-item ef-check-in-dialog-share-item-Instagram"
                                href={gainConfig2.Instagram}
                                onClick={() => {
                                    openHrefHandle(gainConfig2.Instagram, 'Instagram');
                                }}
                            >
                                <div className="ef-check-in-dialog-share-item-icon"></div>
                                <div className="ef-check-in-dialog-share-item-msg">{TextA.Instagram}</div>
                            </EfLink>
                        )}
                        {gainConfig2.Facebook && (
                            <EfLink
                                className="ef-check-in-dialog-share-item ef-check-in-dialog-share-item-Facebook"
                                href={gainConfig2.Facebook}
                                onClick={() => {
                                    openHrefHandle(gainConfig2.Facebook, 'Facebook');
                                }}
                            >
                                <div className="ef-check-in-dialog-share-item-icon"></div>
                                <div className="ef-check-in-dialog-share-item-msg">{TextA.Facebook}</div>
                            </EfLink>
                        )}
                        {gainConfig2.Youtube && (
                            <EfLink
                                className="ef-check-in-dialog-share-item ef-check-in-dialog-share-item-Youtube"
                                href={gainConfig2.Youtube}
                                onClick={() => {
                                    openHrefHandle(gainConfig2.Youtube, 'Youtube');
                                }}
                            >
                                <div className="ef-check-in-dialog-share-item-icon"></div>
                                <div className="ef-check-in-dialog-share-item-msg">{TextA.Youtube}</div>
                            </EfLink>
                        )}
                        {gainConfig2.TitTok && (
                            <EfLink
                                className="ef-check-in-dialog-share-item ef-check-in-dialog-share-item-TitTok"
                                href={gainConfig2.TitTok}
                                onClick={() => {
                                    openHrefHandle(gainConfig2.TitTok, 'TitTok');
                                }}
                            >
                                <div className="ef-check-in-dialog-share-item-icon"></div>
                                <div className="ef-check-in-dialog-share-item-msg">{TextA.TitTok}</div>
                            </EfLink>
                        )}
                        {gainConfig2.Line && (
                            <EfLink
                                className="ef-check-in-dialog-share-item ef-check-in-dialog-share-item-LINE"
                                href={gainConfig2.Line}
                                onClick={() => {
                                    openHrefHandle(gainConfig2.LINE, 'LINE');
                                }}
                            >
                                <div className="ef-check-in-dialog-share-item-icon"></div>
                                <div className="ef-check-in-dialog-share-item-msg">{TextA.LINE}</div>
                            </EfLink>
                        )}
                        {gainConfig2.X && (
                            <EfLink
                                className="ef-check-in-dialog-share-item ef-check-in-dialog-share-item-X"
                                href={gainConfig2.X}
                                onClick={() => {
                                    openHrefHandle(gainConfig2.X, 'X');
                                }}
                            >
                                <div className="ef-check-in-dialog-share-item-icon"></div>
                                <div className="ef-check-in-dialog-share-item-msg">{TextA.X}</div>
                            </EfLink>
                        )}
                        {gainConfig2.Kakoo && (
                            <EfLink
                                className="ef-check-in-dialog-share-item ef-check-in-dialog-share-item-Kakoo"
                                href={gainConfig2.Kakoo}
                                onClick={() => {
                                    openHrefHandle(gainConfig2.Kakoo, 'Kakoo');
                                }}
                            >
                                <div className="ef-check-in-dialog-share-item-icon"></div>
                                <div className="ef-check-in-dialog-share-item-msg">{TextA.Kakoo}</div>
                            </EfLink>
                        )}
                    </div>
                    <div className="ef-check-in-dialog-share-tips">{TextA.desc}</div>
                </div>
            </div>
        </dialog>
    );
}
